import styled from '@emotion/styled';
import { Typography } from 'src/components-dummy';

export const LabelTextStyled = styled(Typography)`
  display: block;
  margin-bottom: 8px;
`;

export const LabelStyled = styled.label`
  display: block;
  margin-top: 24px;
  max-width: 440px;
`;
